export default function log() {
  if (process.env.NODE_ENV !== 'production' || process.env.LOGGING === 'enabled') {
    // eslint-disable-next-line no-console,prefer-rest-params
    console.log.apply(console, arguments);
  }
}
